import { FC } from 'react';
import { cn } from '../../../../utils/cn';
import type { ViewMode } from './types';

interface ViewToggleProps {
  currentView: ViewMode;
  onViewChange: (view: ViewMode) => void;
}

export const ViewToggle: FC<ViewToggleProps> = ({ currentView, onViewChange }) => {
  const views: { value: ViewMode; label: string }[] = [
    { value: 'day', label: 'Day' },
    { value: 'week', label: 'Week' },
    { value: 'month', label: 'Month' },
  ];

  return (
    <div className="inline-flex rounded-lg border border-gray-300 dark:border-slate-600 p-1 bg-gray-100 dark:bg-slate-800">
      {views.map((view) => (
        <button
          key={view.value}
          onClick={() => onViewChange(view.value)}
          className={cn(
            'px-4 py-1.5 text-sm font-medium rounded-md transition-colors',
            currentView === view.value
              ? 'bg-white dark:bg-slate-700 text-gray-900 dark:text-slate-100 shadow-sm'
              : 'text-gray-600 dark:text-slate-400 hover:text-gray-900 dark:hover:text-slate-200'
          )}
        >
          {view.label}
        </button>
      ))}
    </div>
  );
};
